module.exports = __webpack_public_path__ + "static/img/sxlogo.e15422fb.png";